import styled from 'styled-components';

const CustomizationContainer = styled.div`
  width: 100%;
  max-width: 460px;
  margin: 0 auto;

  ${Styles.desktop`
    max-width: 540px;
  `}
`;

export default CustomizationContainer;
